import { lazy } from "react";

export const WorkspaceSettingsView = lazy(
  () => import("./WorkspaceSettingsView"),
);
